import logo from './imgs/OurLogo.png'
import './invoice.css';
export const InvoiceToFill = ({amount, incr, currency, valueInfo}) => {
    return (
        <div className="invoice-container" id="invoice">
            <div className="invoice-header">
              <img src={logo} alt="TV+SA" className="invoice-logo"/>
              <div>TV+SA</div>
              <div>Address:  887, Rue NJO-NJO, Douala</div>
              <div>Phone: +237 6 91408787</div>
              <div>e-mail: contact@lowcosttv.net</div>
              <div>https://lowcosttv.net</div>
            </div>

            <div className="bank-details">
              <div>UBA bank</div>
              {/* <div>39a Chavchavadze ave., Tbilisi, Georgia </div> */}
              <div>SWIFT: UNAFCMCX</div>
              <br />
              <div>Account in {valueInfo?.acc}</div>
              <div> {valueInfo?.bank ? `Correspondent bank: ${valueInfo?.bank}`: ''}</div>
              <div>{valueInfo?.swift ? `SWIFT:  ${valueInfo?.swift}`: ''}</div>
              {/* <div>Beneficiary: GLOBAL LINK LLC</div> */}
            </div>

            <div className="invoice-info">
              <div>Invoice No.{incr}</div>
              <div>Date: {new Date().toLocaleDateString()}</div>
            </div>

            <div className="invoice-table">
              <div className="invoice-table-row">
                <div>Name</div>
                <div>Amount, {currency}</div>
              </div>
              <div className="invoice-table-row">
                <div>Pay TV service</div>
                <div>{amount}</div>
              </div>
            </div>

            <div className="signature">
              {/* <div>Daulet Sutemgenov</div> */}
              <div>TV+SA CEO</div>
            </div>

            <div className="invoice-footer">
              <img src="*" alt="Signature" className="logo"/>
            </div>
        </div>
    )
}